export const isVenueAndUserFromNorthAmerica = (userCountry) => {
    return ((eventDataProps.data.venue.country === 'US' && userCountry === 'US') ||
        (eventDataProps.data.venue.country === 'CA' && userCountry === 'CA'));
};
